import { get, post } from './requests.js'

const AUTOSCALE_API = 'autoscaling-processes'

export const createAutoscaling = (body) => post([AUTOSCALE_API], {}, body)

export const getAutoscaling = (id) => get([AUTOSCALE_API, id])
